document.documentElement.classList.remove('no-js');

const toggle = document.querySelector('[data-menu-toggle]');
const nav = document.querySelector('[data-mobile-nav]');
if (toggle && nav) {
  const closeMobileNav = () => {
    nav.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ct-mobile-menu-open');
  };

  toggle.addEventListener('click', () => {
    const willOpen = nav.hidden;
    nav.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    document.documentElement.classList.toggle('ct-mobile-menu-open', willOpen);
  });

  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileNav));
  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) closeMobileNav();
  });
}

document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => select.form && select.form.submit());
});

const gate = document.querySelector('[data-age-gate]');
if (gate) {
  const storageKey = 'ct_age_verified';
  const shopContext =
    document.body.classList.contains('template-product') ||
    document.body.classList.contains('template-collection') ||
    document.body.classList.contains('template-cart');

  const hasConsent = () => {
    try {
      if (window.localStorage && window.localStorage.getItem(storageKey) === '1') return true;
    } catch (error) {
      // Safari or preview mode can block localStorage. Cookie fallback below.
    }
    return document.cookie.split(';').some((item) => item.trim() === storageKey + '=1');
  };

  const saveConsent = () => {
    try {
      if (window.localStorage) window.localStorage.setItem(storageKey, '1');
    } catch (error) {
      // Cookie fallback remains available.
    }
    document.cookie = storageKey + '=1; path=/; max-age=31536000; SameSite=Lax';
  };

  const closeGate = () => {
    saveConsent();
    gate.hidden = true;
    gate.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  const accept = gate.querySelector('[data-age-accept]');
  if (accept) {
    accept.addEventListener('click', closeGate);
    accept.addEventListener('touchend', (event) => {
      event.preventDefault();
      closeGate();
    }, { passive: false });
  }

  if (shopContext && !hasConsent()) {
    gate.hidden = false;
    gate.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  } else {
    gate.hidden = true;
    gate.setAttribute('aria-hidden', 'true');
  }
}

const siteHeader = document.querySelector('.site-header');
if (siteHeader && document.body.classList.contains('template-index')) {
  const updateHeaderState = () => siteHeader.classList.toggle('is-scrolled', window.scrollY > 40);
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}

const wineCatalogue = document.querySelector('[data-wine-catalogue]');
if (wineCatalogue) {
  const searchInput = wineCatalogue.querySelector('[data-wine-search]');
  const filterButtons = [...wineCatalogue.querySelectorAll('[data-wine-filter]')];
  const cards = [...wineCatalogue.querySelectorAll('[data-wine-card]')];
  const count = wineCatalogue.querySelector('[data-wine-count]');
  const empty = wineCatalogue.querySelector('[data-wine-empty]');
  let activeFilter = 'all';

  const normalize = (value) => (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const matchesCategory = (categories, filter) => {
    if (filter === 'all') return true;
    const value = normalize(categories);
    if (filter === 'rose') return value.includes('rose') || value.includes('rosado');
    if (filter === 'espumante') return value.includes('espumante') || value.includes('sparkling');
    if (filter === 'porto') return value.includes('porto') || value.includes('port-wine');
    return value.includes(filter);
  };

  const updateCatalogue = () => {
    const query = normalize(searchInput && searchInput.value);
    let visible = 0;
    cards.forEach((card) => {
      const text = normalize(card.dataset.search);
      const categoryMatch = matchesCategory(card.dataset.categories, activeFilter);
      const searchMatch = !query || text.includes(query);
      const show = categoryMatch && searchMatch;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (count) count.textContent = visible;
    if (empty) empty.hidden = visible !== 0;
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.wineFilter || 'all';
      filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      updateCatalogue();
    });
  });

  if (searchInput) searchInput.addEventListener('input', updateCatalogue);
  updateCatalogue();
}


// V4.11 — the institutional sheet uses #ficha. Hash fragments are handled only by the browser,
// so Shopify always receives the normal, valid product URL.
(function syncProductViewMode() {
  const updateMode = () => {
    try {
      const institutional = window.location.hash === '#ficha';
      document.documentElement.classList.toggle('ct-institutional-view', institutional);
    } catch (error) {
      document.documentElement.classList.remove('ct-institutional-view');
    }
  };
  updateMode();
  window.addEventListener('hashchange', updateMode);
}());


// V4.18 — quantity controls in the consumer cart.
document.querySelectorAll('.ct-cart__quantity-control').forEach((control) => {
  const input = control.querySelector('[data-cart-quantity-input]');
  const minus = control.querySelector('[data-cart-quantity-minus]');
  const plus = control.querySelector('[data-cart-quantity-plus]');
  if (!input) return;
  if (minus) minus.addEventListener('click', () => {
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
  });
  if (plus) plus.addEventListener('click', () => {
    input.value = (parseInt(input.value, 10) || 0) + 1;
  });
});


// V4.20 — consumer shop filters (type, region and availability).
const shopFilterPanel = document.querySelector('[data-shop-filter-panel]');
if (shopFilterPanel) {
  const filterToggle = shopFilterPanel.querySelector('[data-shop-filter-toggle]');
  const filterContent = shopFilterPanel.querySelector('[data-shop-filter-content]');
  if (filterToggle && filterContent) {
    filterToggle.addEventListener('click', () => {
      const isOpen = shopFilterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
  const typeSelect = shopFilterPanel.querySelector('[data-shop-type-filter]');
  const regionSelect = shopFilterPanel.querySelector('[data-shop-region-filter]');
  const availabilitySelect = shopFilterPanel.querySelector('[data-shop-availability-filter]');
  const clearButton = shopFilterPanel.querySelector('[data-shop-filter-clear]');
  const products = [...document.querySelectorAll('[data-shop-product]')];
  const empty = document.querySelector('[data-shop-filter-empty]');

  const normalize = (value) => (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .trim();

  if (regionSelect) {
    const seen = new Set(['all']);
    [...regionSelect.options].forEach((option) => {
      const key = normalize(option.value);
      if (!key || seen.has(key)) {
        if (option.value !== 'all') option.remove();
      } else {
        seen.add(key);
      }
    });
  }

  const typeMatches = (haystack, selected) => {
    if (selected === 'all') return true;
    const value = normalize(haystack);
    if (selected === 'rose') return value.includes('rose') || value.includes('rosado');
    if (selected === 'espumante') return value.includes('espumante') || value.includes('sparkling');
    if (selected === 'champagne') return value.includes('champagne');
    if (selected === 'porto') return value.includes('vinho do porto') || value.includes('porto') || value.includes('port wine');
    if (selected === 'branco') return value.includes('branco') || value.includes('white') || value.includes('blanc');
    if (selected === 'tinto') return value.includes('tinto') || value.includes('red') || value.includes('rouge');
    return value.includes(selected);
  };

  const applyShopFilters = () => {
    const selectedType = typeSelect ? typeSelect.value : 'all';
    const selectedRegion = regionSelect ? normalize(regionSelect.value) : 'all';
    const selectedAvailability = availabilitySelect ? availabilitySelect.value : 'all';
    let visible = 0;

    products.forEach((product) => {
      const typeOk = typeMatches(product.dataset.shopType, selectedType);
      const regionOk = selectedRegion === 'all' || normalize(product.dataset.shopRegion).includes(selectedRegion);
      const availabilityOk = selectedAvailability === 'all' || product.dataset.shopAvailable === 'true';
      const show = typeOk && regionOk && availabilityOk;
      product.hidden = !show;
      if (show) visible += 1;
    });

    if (empty) empty.hidden = visible !== 0;
  };

  [typeSelect, regionSelect, availabilitySelect].forEach((select) => {
    if (select) select.addEventListener('change', applyShopFilters);
  });

  if (clearButton) clearButton.addEventListener('click', () => {
    if (typeSelect) typeSelect.value = 'all';
    if (regionSelect) regionSelect.value = 'all';
    if (availabilitySelect) availabilitySelect.value = 'all';
    applyShopFilters();
  });

  applyShopFilters();
}

// V4.23 — automatic packshot normalisation for consumer, wine and producer grids.
// It detects the flat background around a bottle, crops only the empty margin in-browser,
// and keeps the original Shopify media untouched.
(function initBottleImageNormaliser() {
  const selector = [
    '.product-card__image img',
    '.ct-wine-card__media img',
    '.ct-approved-product-card__media img'
  ].join(',');
  const cache = new Map();
  const objectUrls = new Set();

  const median = (values) => {
    if (!values.length) return 0;
    values.sort((a, b) => a - b);
    return values[Math.floor(values.length / 2)];
  };

  const canvasToBlob = (canvas) => new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (blob) return resolve(blob);
      canvas.toBlob(resolve, 'image/png');
    }, 'image/webp', 0.98);
  });

  const analyseAndCrop = async (url) => {
    const source = new Image();
    source.crossOrigin = 'anonymous';
    source.decoding = 'async';
    source.src = url;
    await source.decode();

    const naturalWidth = source.naturalWidth;
    const naturalHeight = source.naturalHeight;
    if (!naturalWidth || !naturalHeight) return null;

    const analysisLimit = 360;
    const analysisScale = Math.min(1, analysisLimit / Math.max(naturalWidth, naturalHeight));
    const width = Math.max(1, Math.round(naturalWidth * analysisScale));
    const height = Math.max(1, Math.round(naturalHeight * analysisScale));
    const analysisCanvas = document.createElement('canvas');
    analysisCanvas.width = width;
    analysisCanvas.height = height;
    const analysisContext = analysisCanvas.getContext('2d', { willReadFrequently: true });
    if (!analysisContext) return null;
    analysisContext.drawImage(source, 0, 0, width, height);

    let pixels;
    try {
      pixels = analysisContext.getImageData(0, 0, width, height).data;
    } catch (error) {
      return null;
    }

    const borderSamples = [];
    const stepX = Math.max(1, Math.floor(width / 28));
    const stepY = Math.max(1, Math.floor(height / 28));
    const addSample = (x, y) => {
      const index = (y * width + x) * 4;
      borderSamples.push([pixels[index], pixels[index + 1], pixels[index + 2], pixels[index + 3]]);
    };
    for (let x = 0; x < width; x += stepX) {
      addSample(x, 0);
      addSample(x, height - 1);
      if (height > 5) {
        addSample(x, 2);
        addSample(x, height - 3);
      }
    }
    for (let y = 0; y < height; y += stepY) {
      addSample(0, y);
      addSample(width - 1, y);
      if (width > 5) {
        addSample(2, y);
        addSample(width - 3, y);
      }
    }

    const background = {
      r: median(borderSamples.map((sample) => sample[0])),
      g: median(borderSamples.map((sample) => sample[1])),
      b: median(borderSamples.map((sample) => sample[2])),
      a: median(borderSamples.map((sample) => sample[3]))
    };
    const transparentBackground = background.a < 48;
    const backgroundLuma = (background.r + background.g + background.b) / 3;
    const rowCounts = new Uint32Array(height);
    const columnCounts = new Uint32Array(width);
    const colourThresholdSquared = 42 * 42;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const index = (y * width + x) * 4;
        const alpha = pixels[index + 3];
        if (alpha < 22) continue;
        let foreground = false;
        if (transparentBackground) {
          foreground = alpha > 36;
        } else {
          const redDifference = pixels[index] - background.r;
          const greenDifference = pixels[index + 1] - background.g;
          const blueDifference = pixels[index + 2] - background.b;
          const distanceSquared = redDifference * redDifference + greenDifference * greenDifference + blueDifference * blueDifference;
          const luma = (pixels[index] + pixels[index + 1] + pixels[index + 2]) / 3;
          foreground = distanceSquared > colourThresholdSquared || Math.abs(luma - backgroundLuma) > 30;
        }
        if (foreground) {
          rowCounts[y] += 1;
          columnCounts[x] += 1;
        }
      }
    }

    const rowThreshold = Math.max(2, Math.round(width * 0.006));
    const columnThreshold = Math.max(2, Math.round(height * 0.006));
    let top = 0;
    let bottom = height - 1;
    let left = 0;
    let right = width - 1;
    while (top < height && rowCounts[top] < rowThreshold) top += 1;
    while (bottom > top && rowCounts[bottom] < rowThreshold) bottom -= 1;
    while (left < width && columnCounts[left] < columnThreshold) left += 1;
    while (right > left && columnCounts[right] < columnThreshold) right -= 1;

    if (left >= right || top >= bottom) return null;
    const detectedWidth = right - left + 1;
    const detectedHeight = bottom - top + 1;
    const detectedArea = detectedWidth * detectedHeight;
    if (detectedArea < width * height * 0.012) return null;

    // Photographs and already tightly framed images are left untouched.
    const widthCoverage = detectedWidth / width;
    const heightCoverage = detectedHeight / height;
    if (widthCoverage > 0.93 && heightCoverage > 0.93) return null;

    const horizontalPadding = Math.max(3, Math.round(detectedWidth * 0.14));
    const verticalPadding = Math.max(3, Math.round(detectedHeight * 0.055));
    left = Math.max(0, left - horizontalPadding);
    right = Math.min(width - 1, right + horizontalPadding);
    top = Math.max(0, top - verticalPadding);
    bottom = Math.min(height - 1, bottom + verticalPadding);

    const sourceX = Math.round(left / analysisScale);
    const sourceY = Math.round(top / analysisScale);
    const sourceWidth = Math.min(naturalWidth - sourceX, Math.round((right - left + 1) / analysisScale));
    const sourceHeight = Math.min(naturalHeight - sourceY, Math.round((bottom - top + 1) / analysisScale));
    if (sourceWidth <= 0 || sourceHeight <= 0) return null;

    const outputLimit = 1800;
    const outputScale = Math.min(1, outputLimit / Math.max(sourceWidth, sourceHeight));
    const outputWidth = Math.max(1, Math.round(sourceWidth * outputScale));
    const outputHeight = Math.max(1, Math.round(sourceHeight * outputScale));
    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = outputWidth;
    outputCanvas.height = outputHeight;
    const outputContext = outputCanvas.getContext('2d');
    if (!outputContext) return null;
    outputContext.imageSmoothingEnabled = true;
    outputContext.imageSmoothingQuality = 'high';
    outputContext.drawImage(source, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, outputWidth, outputHeight);
    const blob = await canvasToBlob(outputCanvas);
    if (!blob) return null;
    const objectUrl = URL.createObjectURL(blob);
    objectUrls.add(objectUrl);
    return objectUrl;
  };

  const normalise = async (image) => {
    if (!image || image.dataset.ctImageState) return;
    const originalUrl = image.currentSrc || image.src;
    if (!originalUrl || originalUrl.startsWith('data:') || originalUrl.startsWith('blob:')) return;
    image.dataset.ctImageState = 'processing';
    try {
      if (!cache.has(originalUrl)) cache.set(originalUrl, analyseAndCrop(originalUrl));
      const croppedUrl = await cache.get(originalUrl);
      if (croppedUrl) {
        image.dataset.ctOriginalSrc = originalUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = croppedUrl;
      }
      image.dataset.ctImageState = 'ready';
    } catch (error) {
      image.dataset.ctImageState = 'fallback';
    }
  };

  const observeImages = (root = document) => {
    const images = [...root.querySelectorAll(selector)].filter((image) => !image.dataset.ctImageState);
    if (!images.length) return;
    if (!('IntersectionObserver' in window)) {
      images.forEach(normalise);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        normalise(entry.target);
      });
    }, { rootMargin: '700px 0px' });
    images.forEach((image) => observer.observe(image));
  };

  observeImages();
  document.addEventListener('shopify:section:load', (event) => observeImages(event.target));
  window.addEventListener('pagehide', () => objectUrls.forEach((url) => URL.revokeObjectURL(url)), { once: true });
}());


// V4.30 — AJAX add-to-cart for the consumer shop and product pages.
// Products are added without leaving the current page; cart counters update immediately.
(function initAjaxAddToCart() {
  const forms = [...document.querySelectorAll('[data-ajax-cart-form], .ct-ajax-product-form')];
  if (!forms.length) return;

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${cartRoot.replace(/\/?$/, '/')}cart.js`;

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });
  };

  const getAddEndpoint = (form) => {
    const action = new URL(form.action, window.location.href);
    const pathname = action.pathname.endsWith('.js') ? action.pathname : `${action.pathname}.js`;
    return `${pathname}${action.search}`;
  };

  const refreshCartCount = async () => {
    const response = await fetch(cartUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const cart = await response.json();
    updateCartCount(cart.item_count || 0);
  };

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('[data-add-to-cart-button], button[type="submit"]');
      const feedback = form.querySelector('[data-add-feedback]');
      if (!button || button.disabled) return;

      const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
      const addingLabel = button.dataset.addingLabel || defaultLabel;
      const addedLabel = button.dataset.addedLabel || defaultLabel;
      const formData = new FormData(form);

      button.disabled = true;
      button.classList.remove('is-added', 'has-error');
      button.textContent = addingLabel;
      form.setAttribute('aria-busy', 'true');
      if (feedback) feedback.textContent = '';

      try {
        const response = await fetch(getAddEndpoint(form), {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          let message = '';
          try {
            const error = await response.json();
            message = error.description || error.message || '';
          } catch (parseError) {
            // Use translated fallback below.
          }
          throw new Error(message || form.dataset.errorMessage || 'Unable to add product');
        }

        await refreshCartCount();
        button.textContent = addedLabel;
        button.classList.add('is-added');
        if (feedback) feedback.textContent = addedLabel;

        window.setTimeout(() => {
          button.textContent = defaultLabel;
          button.classList.remove('is-added');
          button.disabled = false;
          form.removeAttribute('aria-busy');
          if (feedback) feedback.textContent = '';
        }, 1700);
      } catch (error) {
        const fallback = document.documentElement.lang.toLowerCase().startsWith('en')
          ? 'Could not add the product. Please try again.'
          : 'Não foi possível adicionar. Tente novamente.';
        button.textContent = defaultLabel;
        button.classList.add('has-error');
        button.disabled = false;
        form.removeAttribute('aria-busy');
        if (feedback) feedback.textContent = error.message || fallback;
      }
    });
  });
}());
